<script>
    import LoadingSpinner from "../LoadingSpinner.svelte";
    import NewCompanyDialog from "../dialogs/NewCompanyDialog.svelte";
    import ContributorModel from "../../models/participaid/Contributor.js";

    import Select, {Option} from '@smui/select';
    import Icon from '@smui/select/icon/index';
    import HelperText from '@smui/select/helper-text/index';
    import Button, {Group, GroupItem, Label} from '@smui/button';

    export let contributors = [];
    export let selected = "";
    export let selectedText = "";
    export let label = "Choose contributor";
    export let help = "";
    export let style;

    // TODO: for some reason the Select value binds to option _label_
    // instead of the Option value.
    // TODO: what if multiple people have the same name?
    $: if (selectedText) {
        for (let contributor of contributors) {
            if (ContributorModel.fmtName(contributor) == selectedText) {
                //selected = contributor.user.id;
                selected = contributor.id
                break;
            }
        }
    }

</script>

<!-- TODO: for some reason it returns the text value instead of the option avlue -->
<!-- TODO: get User from contributor and output name -->
{#if contributors.length}
    <Select variant="outlined" withLeadingIcon bind:value={selectedText} {label} {style} fullwidth>
        <span slot="icon"><Icon class="material-icons">face</Icon></span>
        {#each contributors as contributor}
            <Option
                value={contributor.id}
                selected={selected && selected == contributor.id}>
                {ContributorModel.fmtName(contributor)}
            </Option>
        {/each}
    </Select>
{:else}
    loading...
{/if}

{#if help}
    <HelperText id="helper-text-persistent-c" persistent>{help}</HelperText>
{/if}